import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { getLocale } from 'utils/i18n';
import * as actionTypes from './constants';

export const locale = handleActions(
  {
    [actionTypes.SET_LOCALE]: (state, action) => action.payload,
  },
  getLocale(),
);

export const translations = handleActions(
  {
    [actionTypes.FETCH_TRANSLATIONS_SUCCESS]: (state, action) => action.payload,
    [actionTypes.CLEAR_TRANSLATIONS]: () => ({}),
  },
  {},
);

export const supportedLanguages = handleActions(
  {
    [actionTypes.FETCH_SUPPORTED_LANGUAGES_SUCCESS]: (state, action) => action.payload,
  },
  [],
);


export default combineReducers({
  locale,
  translations,
  supportedLanguages,
});
